import type { SegmentTtsRequest, TtsConfig } from "../shared/types";

export interface ApiErrorDetails {
  used?: number;
  remaining?: number;
  limit?: number;
}

interface ApiErrorPayload {
  error?: {
    code?: string;
    message?: string;
    details?: ApiErrorDetails;
  };
}

export class SegmentRequestError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: ApiErrorDetails,
  ) {
    super(message);
  }
}

async function parseJsonError(response: Response): Promise<SegmentRequestError> {
  try {
    const data = (await response.json()) as ApiErrorPayload;
    return new SegmentRequestError(
      response.status,
      data.error?.code || "HTTP_ERROR",
      data.error?.message || `HTTP ${response.status}`,
      data.error?.details,
    );
  } catch {
    return new SegmentRequestError(
      response.status,
      "HTTP_ERROR",
      `HTTP ${response.status}`,
    );
  }
}

export async function requestSegmentAudio(
  text: string,
  config: TtsConfig,
): Promise<ArrayBuffer> {
  const payload: SegmentTtsRequest = { text, config };

  const response = await fetch("/api/tts/segment", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw await parseJsonError(response);
  }

  return response.arrayBuffer();
}
